import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CarouselComponent} from './carousel.component';
import {SharedModule} from '../../../shared/shared.module';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MarkdownModule} from "ngx-markdown";
import {NoticeBoardDialogDetailComponent} from "./dialog-detail/dialog-detail.component";
import {FitLinesDirective} from './fit-lines.directive';

@NgModule({
    declarations: [
        CarouselComponent,
        NoticeBoardDialogDetailComponent,
        FitLinesDirective
    ],
    imports: [
        SharedModule,
        MatButtonModule,
        MatIconModule,
        MarkdownModule
    ],
    exports: [
        CarouselComponent,
        NoticeBoardDialogDetailComponent
    ]
})
export class CarouselModule {
}
